import {
  fetchJob,
  fetchJobInvitations,
  fetchJobConnections,
  checkIfFirstView
} from '../actions/job';
import loadable from '@loadable/component';
import Loading from '../components/Loader';
import { getJobConnectionsById } from '../selectors/job';
import { fetchSite } from '../actions/sites';

const JobSuccessRoute = loadable(
  () => import(/* webpackChunkName: "success" */ '../containers/JobSuccess'),
  {
    fallback: Loading
  }
);

JobSuccessRoute.needs = async (props, { dispatch, getState }) => {
  dispatch(fetchJobInvitations(props.params.job));
  dispatch(checkIfFirstView(props.params.job));
  await Promise.all([
    dispatch(fetchJob(props.params.job)),
    dispatch(fetchJobConnections(props.params.job))
  ]);
  const connections = getJobConnectionsById(getState(), props.params.job);
  return Promise.all(connections.map(connection => dispatch(fetchSite(connection.siteKey))));
};

export default JobSuccessRoute;
